
















































































import Vue from 'vue'
import { camelizeKeys } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'

const settings = camelizeKeys(require('./phq15.yml'), '-')
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
      rawSettings: require('./phq15.yml'),
      items1Til3: factory.scanRange(1, 3),
      items4Til13: factory.scanRange(4, 13),
      items14Til15: factory.scanRange(14, 15),
      severityItem: factory.item('severityItem'),
      scale: settings.phq9Scale,
    }
  },
})
